export const CALENDAR_EVENTS_QUERY_KEY = 'calendarEvents';
